import React, { FC, ReactNode, useMemo, useState } from 'react';
import { Availability } from '../../../interfaces/Availability';
import ApplicationAvailabilityContext from '../ApplicationAvailabilityContext';

export interface ApplicationAvailabilityProviderProps {
  availability?: Availability;
  children: ReactNode;
}

const ApplicationAvailabilityProvider: FC<ApplicationAvailabilityProviderProps> = ({ availability, children }) => {
  const [availabilityState, setAvailability] = useState(availability || null);

  const saveAvailability = (a: Availability) => {
    setAvailability(a);
  };

  const availabilityProviderValue = useMemo(() => ({ availability: availabilityState, saveAvailability }), [availabilityState]);

  return (
    <ApplicationAvailabilityContext.Provider value={availabilityProviderValue}>
      {children}
    </ApplicationAvailabilityContext.Provider>
  );
};

export default ApplicationAvailabilityProvider;
